import { z } from 'zod';

export const simpleDoctorAttendingSchema = z.object({
  id: z.string().uuid(),
  firstname: z.string(),
  lastname: z.string(),
});
